"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _formFields = require("@trodly/form-fields");

var _LocationBased = _interopRequireDefault(require("./LocationBased"));

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

var _activityBaseModule = _interopRequireDefault(require("./styles/activity-base.module.css"));

var _actions = require("../actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ActivityBased =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ActivityBased, _React$Component);

  function ActivityBased(props) {
    var _this;

    _classCallCheck(this, ActivityBased);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActivityBased).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setEnquiryType", function (bool, type) {
      var _this$props = _this.props,
          onSet = _this$props.onSet,
          queryType = _this$props.queryType;

      if (type === "askQues") {
        onSet({
          queryType: "askQues",
          id: queryType.id
        });

        _this.setState({
          locationBased: false
        });
      } else {
        onSet({
          queryType: "locationBased",
          id: null
        });

        _this.setState({
          locationBased: true
        });
      }
    });

    _this.state = {
      name: "",
      locationBased: false
    };
    return _this;
  }

  _createClass(ActivityBased, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          onSet = _this$props2.onSet,
          queryType = _this$props2.queryType,
          enquiryFor = _this$props2.enquiryFor,
          setSource = _this$props2.setSource;
      setSource(queryType.id);

      if (enquiryFor.queryType) {
        onSet({
          queryType: enquiryFor.queryType,
          id: enquiryFor.id,
          name: enquiryFor.name
        });

        if (enquiryFor.queryType === "locationBased") {
          this.setState({
            locationBased: true
          });
        }
      } else {
        onSet({
          queryType: "askQues",
          id: queryType.id
        });
      }

      this.setState({
        name: queryType.name
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          locationBased = _this$state.locationBased,
          name = _this$state.name;
      var _this$props3 = this.props,
          onSet = _this$props3.onSet,
          enquiryFor = _this$props3.enquiryFor;
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: "".concat(_activityBaseModule.default.radioContainer, " ").concat(!locationBased ? "" : _activityBaseModule.default.radioContainerInactive)
      }, _react.default.createElement(_formFields.Radio, {
        name: "queryType",
        value: "askQues",
        checked: !locationBased || enquiryFor.queryType === "askQues",
        label: name,
        onChange: function onChange(bool) {
          return _this2.setEnquiryType(bool, "askQues");
        }
      })), _react.default.createElement("div", {
        className: "".concat(_activityBaseModule.default.radioContainer, " ").concat(locationBased ? "" : _activityBaseModule.default.radioContainerInactive)
      }, _react.default.createElement(_formFields.Radio, {
        name: "queryType",
        value: "locationBased",
        label: "Open for more options",
        checked: locationBased || enquiryFor.queryType === "locationBased",
        onChange: function onChange(bool) {
          return _this2.setEnquiryType(bool, "locationBased");
        }
      })), locationBased && _react.default.createElement(_LocationBased.default, {
        onSet: onSet
      }));
    }
  }]);

  return ActivityBased;
}(_react.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    enquiryFor: state.enquiryFor,
    queryType: state.queryType
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setEnquiry: function setEnquiry(enquiry) {
      return dispatch((0, _actions.setEnquiry)(enquiry));
    },
    setSource: function setSource(source) {
      return dispatch((0, _actions.setSource)(source));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActivityBased);

exports.default = _default;